import React, { useEffect, useState } from 'react';
import { basicsettinglist, UpdateNotificationSettings } from '../../../Services/Admin/Admin';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';

const NotificationTemplate = () => {
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('id');
    const navigate = useNavigate();

    const [clients, setClients] = useState(null);

    const getsettingdetail = async () => {
        try {
            const response = await basicsettinglist(token);
            if (response.status) {
                setClients(response.data);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        getsettingdetail();
    }, []);

    const validationSchema = Yup.object().shape({
        push_cash: Yup.string().required('Push Cash is required'),
        push_future: Yup.string().required('Push Future is required'),
        push_option: Yup.string().required('Push Option is required'),
        push_strategy: Yup.string().required('Push Strategy is required'),
    });

    if (!clients) {
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className='page-content'>
            <div className="page-breadcrumb d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Notification Template</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-12 mx-auto">
                    <div className="card radius-15">
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                id: user_id,
                                push_cash: clients[0].push_cash || '',
                                push_future: clients[0].push_future || '',
                                push_option: clients[0].push_option || '',
                                push_strategy: clients[0].push_strategy || '',
                            }}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { setSubmitting }) => {
                                const req = {
                                    push_cash: values.push_cash,
                                    push_future: values.push_future,
                                    push_option: values.push_option,
                                    push_strategy: values.push_strategy,
                                    id: user_id,
                                };

                                try {
                                    const response = await UpdateNotificationSettings(req, token);
                                    if (response.status) {
                                        showCustomAlert("Success", response.message);
                                        getsettingdetail();
                                    } else {
                                        showCustomAlert("error", response.message);
                                    }
                                } catch (error) {
                                    showCustomAlert("error", "An unexpected error occurred. Please try again later.");
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ dirty, isSubmitting }) => (
                                <Form className="card-body">
                                    <div className="row mb-3 align-items-center">
                                        <label htmlFor="push_cash" className="col-sm-3 col-form-label"><b>Push Cash</b></label>
                                        <div className="col-sm-9">
                                            <Field name="push_cash" type="text" className="form-control mb-2" />
                                            <ErrorMessage name="push_cash" component="div" className="error" />
                                        </div>
                                    </div>

                                    <div className="row mb-3 align-items-center">
                                        <label htmlFor="push_future" className="col-sm-3 col-form-label"><b>Push Future</b></label>
                                        <div className="col-sm-9">
                                            <Field name="push_future" type="text" className="form-control" />
                                            <ErrorMessage name="push_future" component="div" className="error" />
                                        </div>
                                    </div>

                                    <div className="row mb-3 align-items-center">
                                        <label htmlFor="push_option" className="col-sm-3 col-form-label"><b>Push Option</b></label>
                                        <div className="col-sm-9">
                                            <Field name="push_option" type="text" className="form-control" />
                                            <ErrorMessage name="push_option" component="div" className="error" />
                                        </div>
                                    </div>

                                    <div className="row mb-3 align-items-center">
                                        <label htmlFor="push_strategy" className="col-sm-3 col-form-label"><b>Push Strategy</b></label>
                                        <div className="col-sm-9">
                                            <Field name="push_strategy" type="text" className="form-control" />
                                            <ErrorMessage name="push_strategy" component="div" className="error" />
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <label className="col-sm-3 col-form-label" />
                                        <div className="col-sm-9">
                                            <div className="d-md-flex d-grid align-items-center justify-content-end gap-3">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4"
                                                    disabled={!dirty || isSubmitting}
                                                >
                                                    {isSubmitting ? 'Updating...' : 'Update'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <style jsx>{`
                            .error {
                                color: red;
                                font-size: 14px;
                                margin-top: 5px;
                            }
                        `}</style>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationTemplate;
